// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1iM1S","title":"Header_title__3_hz_","side":"Header_side__1PRld"};